export function Loading({ label = "Loading..." }: { label?: string }) {
  return (
    <div className="flex flex-col items-center gap-3 text-white">
      <div className="h-12 w-12 animate-spin rounded-full border-4 border-white/30 border-t-amber-400" />
      <p className="text-lg font-semibold">{label}</p>
    </div>
  );
}
